module.exports = __webpack_public_path__ + "static/netlify-f8dbd6629921cf220076322fd56fde2f.png";